import React, { Component, Fragment } from 'react';

import { Row, Col, Button, Input, Icon } from 'antd';

import { inject, observer } from 'mobx-react';

import './Search.css';

@inject('translationsStore', 'leadsStore')
@observer
export default class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      textToSearch: ''
    };
  }

  onTextSearchChange = e => {
    this.setState({ textToSearch: e.target.value });
  };

  emitEmpty = () => {
    this.resetSearch();
  };

  keyPress = e => {
    if (e.keyCode === 13) {
      this.search();
    }
  };

  search = () => {
    const { leadsStore } = this.props;
    const { textToSearch } = this.state;
    leadsStore.search(textToSearch);
  };

  resetSearch = () => {
    const { leadsStore } = this.props;
    const textToSearch = '';
    leadsStore.search();
    this.setState({ textToSearch });
  };

  render() {
    const { translationsStore } = this.props;
    const { textToSearch } = this.state;
    // for suffix, <Fragment /> instead of null avoids input focus loss
    const suffix = textToSearch ? <Icon type="close-circle" onClick={this.emitEmpty} /> : <Fragment />;
    return (
      <Row type="flex" className="Search">
        <Col style={{ flex: 'auto' }}>
          <Input
            onKeyDown={this.keyPress}
            suffix={suffix}
            name="fulltextsearch"
            value={textToSearch}
            onChange={this.onTextSearchChange}
            placeholder={translationsStore.translate('search.placeholder')}
          />
        </Col>
        <Col style={{ paddingLeft: '15px' }}>
          <Button style={{ width: 124 }} type="primary" onClick={this.search}>
            {translationsStore.translate('search.action')}
          </Button>
        </Col>
      </Row>
    );
  }
}
